module.exports = __webpack_public_path__ + "img/dashboardRightIcon.9fb676aa.svg";